<template>
  <section class="approveListBoxPa posiab"
    :style="{
      top: boxTop,
    }"
  >
    <qx-card :title="tabVal === '1' ? '待我处理' : '我发起的'" padding="0">
      <section
        class="listBox transition"
        v-infinite-scroll="getData"
        v-qx-full-h="{
          tar: 'height',
          height: delHeight,
        }"
      >
        <section class="noData" v-show="tableData.data.length === 0 && !tableData.hasNext">暂无数据</section>
        <section
          v-for="item in tableData.data"
          :key="item.id"
          class="approveItem posire cur"
          :class="{active: activeItem.id === item.id}"
          @click="choose(item)"
        >
          <img v-if="item.applyUserFileUrl" class="userImg posiab" :src="item.applyUserFileUrl" />
          <img v-if="!item.applyUserFileUrl" class="userImg posiab" src="~images/user.png" />
          <!-- title -->
          <h2 class="title">{{item.applyUserName}}提交的{{item.busiRemarks}}</h2>
          <article class="date">{{item.applyDate}}</article>
        </section>
        <section class="isBottom" v-show="tableData.data.length !== 0 && !tableData.hasNext">已经到底了</section>
      </section>
    </qx-card>
  </section>
</template>

<script>
import {
  waitApproveList,
} from 'api';
import ws from '@qx/mixin/ws';
export default {
  mixins: [ws],
  props: {
    isShow: {
      type: Boolean,
    },
    tabVal: {
      type: String,
    },
  },
  data () {
    return {
      boxTop: 0,
      delHeight: 318, // 高度计算减值
      searchBoxData: {},
      activeItem: {},
      tableData: {
        loading: false,
        count: 20,
        page: 1,
        data: [],
        hasNext: false,
      },
    };
  },
  watch: {
    isShow () {
      this.getData();
    },
  },
  methods: {
    handleWsMsg (msg) { // 接收信息
      if (this.tabVal === '2') {
        return;
      }
      if (msg.status === 0) { // 待处理 - 添加
        this.tableData.data.unshift(msg);
      } else { // 已处理/已失效 - 删除
        for (let i = 0; i < this.tableData.data.length; i++) {
          if (this.tableData.data[i].id === msg.id) {
            this.tableData.data.splice(i, 1);
            if (this.activeItem.id === msg.id && this.tableData.data.length !== 0) {
              this.choose(this.tableData.data[0]);
            }
            break;
          }
        }
      }
      // 删除之后如果当前数据为空 且 还有数据，请求下一页
      if (this.tableData.data.length === 0 && this.tableData.hasNext) {
        this.getData();
      }
    },
    toAllApprove () {
      this.jump({
        label: '待我处理',
        url: '/manage/index/workspace/allApprove',
      });
    },
    async getData (searchBoxData) {
      if (searchBoxData) {
        this.tableData.page = 1;
        this.tableData.hasNext = true;
        this.tableData.loading = false;
        this.tableData.data = [];
        this.searchBoxData = searchBoxData;
      }
      if (!this.tableData.hasNext || this.tableData.loading || !this.isShow) {
        return;
      }
      this.tableData.loading = true;
      let data = {};
      if (this.tabVal === '1') {
        data.status = 0;
      }
      const res = await waitApproveList({
        ...this.searchBoxData,
        ...data,
        count: this.tableData.count,
        page: this.tableData.page,
      });
      if (this.tableData.data.length === 0 && res.items[0]) {
        this.choose(res.items[0]);
      }
      this.tableData.page++;
      this.tableData.hasNext = res.hasNext;
      this.tableData.data.push(...res.items);
      this.$nextTick(() => {
        this.tableData.loading = false;
      });
    },
    handleBoxPosition () {
      const scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 244) {
        this.boxTop = scrollTop - 244 + 'px';
        this.delHeight = 66;
      } else {
        this.boxTop = 0;
        this.delHeight = 318 - scrollTop;
      }
    },
    choose (item) {
      this.activeItem = item;
      this.$emit('choose', item);
    },
  },
  created () {
    window.addEventListener('scroll', this.handleBoxPosition);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleBoxPosition);
  },
};
</script>

<style scoped lang="scss">
.approveListBoxPa{
  top: 0;
  left: 0;
  .approveItem{
    padding-left: 68px;
    width: 300px;
    height: 64px;
    box-sizing: border-box;
    border-bottom: 1px solid #e0e0e0;
    .userImg{
      width: 34px;
      height: 34px;
      border-radius: 50%;
      top: 8px;
      left: 24px;
    }
    .title{
      height: 14px;
      line-height: 14px;
      margin-bottom: 10px;
      padding-top: 18px;
    }
    .date{
      font-size: 12px;
      height: 12px;
      line-height: 12px;
      color: #999;
    }
  }
  .active{
    background: #fafafa;
  }
}
.listBox{
  width: 300px;
  overflow: auto;
  .noData{
    padding-top: 100px;
    text-align: center;
  }
  .isBottom{
    text-align: center;
    padding: 8px 0;
  }
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #999;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #e0e0e0;
  }
}
</style>
